const SldsPath = () => {
    return (
        <>
            <div class="slds-path">
                <div class="slds-grid slds-path__track">
                    <div class="slds-grid slds-path__scroller-container">
                        <div class="slds-path__scroller">
                            <div class="slds-path__scroller_inner">
                                <ul class="slds-path__nav" role="listbox" aria-orientation="horizontal" aria-labelledby="slds-path__stage-name">
                                    <li class="slds-path__item slds-is-complete" role="presentation">
                                        <a aria-selected="false" class="slds-path__link" href="#" id="path-6" role="option" tabindex="-1">
                                            <span class="slds-path__stage">
                                                <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                                                </svg>
                                                <span class="slds-assistive-text">Stage Complete</span>
                                            </span>
                                            <span class="slds-path__title">Contacted</span>
                                        </a>
                                    </li>
                                    <li class="slds-path__item slds-is-complete" role="presentation">
                                        <a aria-selected="false" class="slds-path__link" href="#" id="path-7" role="option" tabindex="-1">
                                            <span class="slds-path__stage">
                                                <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                                                </svg>
                                                <span class="slds-assistive-text">Stage Complete</span>
                                            </span>
                                            <span class="slds-path__title">Open</span>
                                        </a>
                                    </li>
                                    <li class="slds-path__item slds-is-complete" role="presentation">
                                        <a aria-selected="false" class="slds-path__link" href="#" id="path-8" role="option" tabindex="-1">
                                            <span class="slds-path__stage">
                                                <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                                                </svg>
                                                <span class="slds-assistive-text">Stage Complete</span>
                                            </span>
                                            <span class="slds-path__title">Unqualified</span>
                                        </a>
                                    </li>
                                    <li class="slds-path__item slds-is-current slds-is-active" role="presentation">
                                        <a aria-selected="true" class="slds-path__link" href="#" id="path-9" role="option" tabindex="0">
                                            <span class="slds-path__stage">
                                                <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                                                </svg>
                                                <span class="slds-assistive-text">Current Stage:</span>
                                            </span>
                                            <span class="slds-path__title">Nurturing</span>
                                        </a>
                                    </li>
                                    <li class="slds-path__item slds-is-incomplete" role="presentation">
                                        <a aria-selected="false" class="slds-path__link" href="#" id="path-10" role="option" tabindex="-1">
                                            <span class="slds-path__stage">
                                                <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                                                </svg>
                                            </span>
                                            <span class="slds-path__title">Closed</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="slds-grid slds-path__action">
                        <span id="slds-path__stage-name" class="slds-path__stage-name">Stage: Unqualified</span>
                        <button class="slds-button slds-button_brand slds-path__mark-complete">
                            <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
                                <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#check"></use>
                            </svg>Mark Status as Complete</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SldsPath;